import { memo, useState } from "react";
import { Checkbox, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { SelectList } from "components";
import { getNSLang } from "utils/lang.utils";
import { LangConstant } from "const";
import theme from "theme/material";
import { styled } from "@mui/styles";

const GroupMemberFilter = ({ groupMembers, onChange }) => {
  const DEFAULT_SELECT_TEXT = getNSLang(LangConstant.NS_HOME_CONVERSATION, "TXT_MEMBERS");
  const [selectedText, setSelectedText] = useState(DEFAULT_SELECT_TEXT);
  const [selectMemberList, setSelectMemberList] = useState([]);

  const handleClickItemFunc = item => () => {
    const currentIndex = selectMemberList.indexOf(item.id);
    const newMemberList = [...selectMemberList];

    if (currentIndex === -1) {
      newMemberList.push(item.id);
    } else {
      newMemberList.splice(currentIndex, 1);
    }

    switch (newMemberList.length) {
      case 0:
        setSelectedText(DEFAULT_SELECT_TEXT);
        break;

      case 1:
        const selectedItem = groupMembers.find(member => member.id === newMemberList[0]);
        setSelectedText(selectedItem.name);
        break;

      default:
        setSelectedText(`${newMemberList.length} ${DEFAULT_SELECT_TEXT.toLowerCase()}`);
        break;
    }

    setSelectMemberList(newMemberList);
    if (onChange) onChange(newMemberList);
  };

  return (
    <SelectList
      selectedText={selectedText}
      disableClickItemEvent
      PopperProps={{ sx: { zIndex: theme.zIndex.drawer + 1 } }}
      SelectedTextProps={{ minWidth: "unset", fontSize: "0.875rem" }}
      PaperProps={{ sx: { maxHeight: "200px", overflowY: "auto" } }}
    >
      <List>
        {groupMembers.map(item => (
          <ListItem disablePadding key={item.id} onClick={handleClickItemFunc(item)}>
            <ItemButton>
              <ItemIcon>
                <CheckboxIcon
                  edge="start"
                  checked={selectMemberList.indexOf(item.id) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ "aria-labelledby": item.name }}
                />
              </ItemIcon>
              <ListItemText primary={item.name} className="ellipsis" />
            </ItemButton>
          </ListItem>
        ))}
      </List>
    </SelectList>
  );
};

export default memo(GroupMemberFilter);

const ItemButton = styled(ListItemButton)(props => ({
  minWidth: 156,

  "&:hover": {
    background: props.theme.palette.primary.main,
    "&, & *": { color: "white" },
  },
}));

const ItemIcon = styled(ListItemIcon)({
  minWidth: 36,
  paddingLeft: 6,
});

const CheckboxIcon = styled(Checkbox)({
  padding: 0,
});
